import { KeyConstructor } from './keyConstructor';
const MEMBER_SPACE_MEMBERSHIP_REQUEST = 'memberSpaceMembershipRequest';
const SPACE_MEMBERSHIP_REQUEST = 'spaceMembershipRequest';
export const getMemberSpaceMembershipRequestKey = KeyConstructor(MEMBER_SPACE_MEMBERSHIP_REQUEST);
export const getSpaceMembershipRequestKey = KeyConstructor(SPACE_MEMBERSHIP_REQUEST);
//# sourceMappingURL=spaceMembership.key.js.map